var _path, _path2, _mask, _g, _mask2, _g2, _mask3, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCandidate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 24,
    viewBox: "0 0 138 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.9256 5L76.0549 7.89601L78.1932 5H79.1115V11.1177H78.0988V6.73287L76.0639 9.5061L74.0115 6.72399V11.1177H73.0074V5H73.9256ZM81.0802 11.1177V5H82.0934V9.39509L85.5186 5H86.3944V11.1177H85.3903V6.71511L81.956 11.1177H81.0802ZM90.3059 8.9985H89.3707V11.1177H88.3654V5H90.3059C91.5594 5 92.4188 5.87014 92.4188 6.99923C92.4188 8.12837 91.5594 8.9985 90.3059 8.9985ZM90.2923 5.94858H89.3651V8.04995H90.2923C91.0138 8.04995 91.4248 7.59412 91.4248 6.99923C91.4248 6.40434 91.0194 5.94858 90.2923 5.94858ZM73 19.7273V13.6097H74.0126V18.0033L77.4379 13.6097H78.3137V19.7273H77.3169V15.3233L73.8758 19.7273H73ZM80.2858 13.6097H81.2984V16.1432H84.3109V13.6097H85.3168V19.7273H84.3109V17.0991H81.2984V19.7273H80.2932L80.2858 13.6097ZM87.2838 13.6097H89.3877C90.4772 13.6097 91.2071 14.3762 91.2071 15.2982C91.2168 15.527 91.1704 15.7546 91.0715 15.9612C90.9731 16.1676 90.8249 16.3465 90.6412 16.482C90.9363 16.5902 91.1902 16.7892 91.366 17.0507C91.5419 17.3122 91.6306 17.6229 91.6199 17.9382C91.6199 18.946 90.8119 19.7303 89.6534 19.7303H87.2838V13.6097ZM89.3362 16.1861C89.8847 16.1861 90.2211 15.8324 90.2211 15.3588C90.2211 14.9149 89.8847 14.5317 89.3362 14.5317H88.288V16.1861H89.3362ZM89.6308 18.8054C90.2827 18.8054 90.644 18.4428 90.644 17.9264C90.644 17.4099 90.2827 17.0473 89.6308 17.0473H88.288V18.8054H89.6308ZM93.2155 13.6097H96.8821V14.5745H94.2208V16.1432H96.3659V17.108H94.2208V18.7625H96.8821V19.7273H93.2155V13.6097ZM98.0118 16.6685C98.0118 14.8764 99.3688 13.506 101.189 13.506C102.664 13.506 103.825 14.462 104.126 15.6607H103.043C102.787 14.9622 102.048 14.4768 101.189 14.4768C99.9183 14.4768 99.025 15.4328 99.025 16.6655C99.025 17.8982 99.9183 18.8541 101.189 18.8541C102.048 18.8541 102.787 18.3717 103.043 17.6703H104.126C103.83 18.8675 102.651 19.8249 101.189 19.8249C99.3688 19.8309 98.0118 18.4605 98.0118 16.6685ZM106.853 14.5745H105.083V13.6097H109.634V14.5745H107.865V19.7273H106.86L106.853 14.5745ZM111.061 19.7273V13.6097H112.074V18.0033L115.507 13.6097H116.382V19.7273H115.377V15.3233L111.937 19.7273H111.061ZM123.877 18.7625V21H122.95V19.7273H118.348V13.6097H119.361V18.7625H122.092V13.6097H123.105V18.7625H123.877ZM125.399 19.7273V13.6097H126.418V18.0033L129.843 13.6097H130.719V19.7273H129.715V15.3233L126.271 19.7273H125.399ZM132.685 19.7273V13.6096H133.698V18.0033L137.124 13.6096H138V19.7273H136.995V15.3233L133.56 19.7273H132.685ZM133.999 11.791H134.659C134.659 12.3089 134.954 12.627 135.425 12.627C135.894 12.627 136.188 12.3089 136.188 11.791H136.849C136.855 11.9826 136.822 12.1736 136.754 12.3525C136.685 12.5314 136.581 12.6946 136.448 12.8324C136.315 12.9702 136.156 13.0798 135.98 13.1546C135.804 13.2294 135.615 13.268 135.423 13.268C135.232 13.268 135.044 13.2294 134.867 13.1546C134.691 13.0798 134.532 12.9702 134.4 12.8324C134.267 12.6946 134.163 12.5314 134.094 12.3525C134.025 12.1736 133.992 11.9826 133.999 11.791Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1408 11.0118C36.7122 11.2193 37.2399 11.5311 37.6969 11.9312C38.1309 12.3497 38.4849 12.8435 38.7416 13.3884C38.9929 13.9687 39.1184 14.5953 39.1098 15.2274C39.1184 15.8523 38.9929 16.4719 38.7416 17.0445C38.487 17.5907 38.1259 18.0809 37.6794 18.4864C37.2329 18.8919 36.7098 19.2048 36.1408 19.4066C35.5046 19.64 34.8316 19.758 34.1537 19.7548H27V5.25148H37.8591V8.07112H29.9895V10.6853H34.1522C34.8292 10.6756 35.5026 10.7861 36.1408 11.0118ZM35.6469 13.8693C35.2044 13.5411 34.6622 13.375 34.1113 13.3986H29.9895V17.0168H34.1113C34.6619 17.0402 35.2039 16.8745 35.6469 16.5476C36.0371 16.2416 36.2212 15.819 36.2212 15.2201C36.2212 14.6212 36.0371 14.1782 35.6469 13.8693ZM44.6532 19.7548H41.7923V5.25148H44.6532V11.4008L49.7394 5.25148H53.2958L47.4951 12.2168L54.5085 19.7548H50.7739L44.6532 13.1771V19.7548ZM58.8993 19.4066C57.0958 18.6637 55.6603 17.2394 54.9059 15.4445C54.5177 14.5124 54.3224 13.5117 54.3317 12.5025C54.3214 11.514 54.508 10.5332 54.8807 9.61723C55.2536 8.70119 55.8049 7.86811 56.503 7.16628C57.1899 6.48456 58.004 5.9435 58.8993 5.57356C59.8675 5.17991 60.9057 4.98514 61.9517 5.00088C62.7579 4.99836 63.5597 5.12228 64.3273 5.36809C65.0702 5.62599 65.7734 5.98598 66.4166 6.43765C67.0289 6.89899 67.5674 7.45029 68.0139 8.07262C68.4677 8.71573 68.8005 9.43556 68.9972 10.1972H65.7823C65.6428 9.83416 65.4344 9.5013 65.1688 9.21651C64.8988 8.92654 64.5878 8.67763 64.2455 8.47774C63.902 8.28683 63.5378 8.13624 63.1597 8.02889C62.7658 7.92332 62.3596 7.86845 61.9517 7.86572C61.3068 7.85881 60.6664 7.97658 60.0664 8.21251C59.5111 8.44142 59.0097 8.78225 58.5923 9.21361C58.1878 9.63962 57.8678 10.1386 57.6499 10.6839C57.4252 11.2635 57.3154 11.8812 57.3272 12.5025C57.3171 13.1241 57.428 13.7417 57.6544 14.321C57.8723 14.8663 58.1917 15.3653 58.5968 15.7913C59.0091 16.223 59.5128 16.5579 60.0708 16.772C60.6664 17.0246 61.3085 17.1497 61.9556 17.1392C62.3641 17.1365 62.7703 17.0817 63.1641 16.976C63.5463 16.8705 63.9116 16.7126 64.25 16.5068C64.5951 16.3217 64.9072 16.0798 65.1716 15.7913C65.4372 15.5066 65.6456 15.1737 65.7857 14.8107H69C68.8033 15.5659 68.47 16.2789 68.0167 16.9148C67.5758 17.5417 67.0362 18.0937 66.4194 18.5498C65.7857 19.0145 65.0797 19.3733 64.3301 19.612C63.5659 19.8744 62.7624 20.0055 61.9545 19.9997C60.9062 20.0092 59.8669 19.8075 58.8993 19.4066Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 22,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 23C17.0751 23 22 18.0751 22 12C22 5.92486 17.0751 1 11 1C4.92487 1 0 5.92486 0 12C0 18.0751 4.92487 23 11 23Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8383 17.5317C23.882 12.1389 21.8881 5.24919 16.3847 2.14314C10.8813 -0.962908 3.95258 0.890898 0.908905 6.28376C-2.13477 11.6766 -0.140785 18.5663 5.36258 21.6723C10.8659 24.7784 17.7947 22.9246 20.8383 17.5317Z",
    fill: "url(#paint0_linear)"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 22,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 23C17.0751 23 22 18.0751 22 12C22 5.92486 17.0751 1 11 1C4.92487 1 0 5.92486 0 12C0 18.0751 4.92487 23 11 23Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.095 16.4252C23.9993 12.438 22.5187 6.41219 17.7879 2.96634C13.0571 -0.479535 6.86766 -0.0406626 3.96338 3.94658C1.05909 7.93384 2.53975 13.9596 7.2705 17.4054C12.0013 20.8513 18.1908 20.4124 21.095 16.4252Z",
    fill: "url(#paint1_radial)"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 22,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 23C17.0751 23 22 18.0751 22 12C22 5.92486 17.0751 1 11 1C4.92487 1 0 5.92486 0 12C0 18.0751 4.92487 23 11 23Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1697 11.29C22.6105 8.49624 20.2731 4.42386 15.9491 2.19401C11.6252 -0.035836 6.95202 0.421272 5.51133 3.21499C4.07062 6.00868 6.40797 10.0811 10.7319 12.3109C15.0558 14.5408 19.729 14.0837 21.1697 11.29Z",
    fill: "url(#paint2_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 17.0273,
    y1: 37.1864,
    x2: 10.5571,
    y2: -3.1291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0570EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#1277F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2884F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4896F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70ADF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A1C9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#DBEAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2416 15.4664) rotate(105.292) scale(16.9109 28.3481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#006DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0671EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#187BF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#358BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5EA3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#92C1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D1E4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F0F6FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4546 4.93055) rotate(48.2923) scale(24.0825 20.2951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#006DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0F75F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#529CF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8BBCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B6D5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D6E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#E9F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F0F6FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCandidate);
export default __webpack_public_path__ + "static/media/logo_candidate.dd32399760a2caee879423bc928d807b.svg";
export { ForwardRef as ReactComponent };